import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ref, set, update, serverTimestamp } from "firebase/database";
import { database } from "../firebaseConfig";
import { YEAR, BOOKING_ROUND } from "../config";
import { bookedSetsDelta } from "../inventory";

export const confirm = createAsyncThunk(
  "conf/confirm",
  async (confirmation, { rejectWithValue }) => {
    const { referenceId, uid } = confirmation;
    try {
      const userRef = ref(
        database,
        `users/${uid}/confirmations${YEAR}/${referenceId}`,
      );
      await set(userRef, {
        ...confirmation,
        round: BOOKING_ROUND,
        createdAt: serverTimestamp(),
      });
      try {
        // Best-effort: the reservation stands even if the counters fail.
        const delta = bookedSetsDelta(confirmation.cart, +1);
        if (Object.keys(delta).length) await update(ref(database), delta);
      } catch (error) {
        console.warn("Failed to update availability counters:", error);
      }
      return confirmation;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const saveCart = createAsyncThunk(
  "conf/saveCart",
  async (cart, { rejectWithValue }) => {
    const { uid } = cart;
    try {
      const userRef = ref(database, `users/${uid}/cart${YEAR}`);
      await set(userRef, cart);
      return cart;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const confSlice = createSlice({
  name: "conf",
  initialState: {
    confirmation: null,
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetConf: (state) => {
      state.confirmation = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirm.fulfilled, (state, action) => {
        state.confirmation = action.payload;
        state.error = null;
      })
      .addCase(confirm.rejected, (state, action) => {
        state.error = action.payload;
        state.confirmation = null;
      })
      .addCase(saveCart.fulfilled, (state, action) => {
        state.user = action.payload;
        state.error = null;
      })
      .addCase(saveCart.rejected, (state, action) => {
        state.error = action.payload;
        state.user = null;
      });
  },
});

export const { resetConf } = confSlice.actions;

export default confSlice.reducer;
